import React from 'react';
import { motion } from 'framer-motion';
import { FlaskConicalIcon, LockIcon, MailIcon, ShieldIcon, RefreshCwIcon } from 'lucide-react';
const pack = {
  id: 'megapack',
  title: 'BIBLIOTECA QUÍMICA VISUAL™ — EDICIÓN LATAM',
  subtitle: 'Todo lo que necesitas para explicar, practicar, evaluar y recuperar contenidos de Química en educación secundaria.',
  savings: 'OFERTA ESPECIAL DE LANZAMIENTO',
  features: ['Fichas visuales y ejemplos para explicar.', 'Actividades listas para imprimir y utilizar.', 'Actividades y evaluaciones en versiones A y B.', 'Juegos y desafíos para el aula.', 'Historietas científicas: Los Chismes de la Tabla Periódica y Elementos Infieles.', 'Recursos para práctica, evaluación y recuperación.', 'Documentos completos y fichas individuales.', '5 cuadernillos visuales de apoyo incluidos sin costo adicional.', 'Acceso digital inmediato por correo electrónico.', 'Garantía de satisfacción de 7 días.'],
  oldPrice: 'USD 49',
  price: 'USD 16.99',
  url: 'https://quimica-visual-secundaria.impultienda.ar/checkout'
};
const badges = [{
  icon: LockIcon,
  title: 'PAGO PROTEGIDO',
  desc: 'Pago seguro internacional'
}, {
  icon: MailIcon,
  title: 'ACCESO INMEDIATO',
  desc: 'Entrega digital por correo electrónico'
}, {
  icon: ShieldIcon,
  title: 'GARANTÍA DE 7 DÍAS',
  desc: 'Compra sin riesgo'
}, {
  icon: RefreshCwIcon,
  title: 'CONVERSIÓN AUTOMÁTICA',
  desc: 'Pago en tu moneda local desde el checkout'
}];
export function Pricing() {
  const handlePurchase = () => {
    window.location.href = pack.url;
  };
  return <section id="pricing" className="py-2 md:py-12 px-4 max-w-4xl mx-auto min-h-[100dvh] flex flex-col justify-center" data-id="element-153" data-mp="3n5ak0xqg83hg">
      <div className="text-center mb-2 md:mb-10" data-id="element-154" data-mp="2uj96p2wi5vmn">
        <h2 className="text-xl md:text-5xl font-black text-chem-navy mb-1 md:mb-4 leading-tight" data-id="element-155" data-mp="2ugn31ecqg09p">
          Recupera horas de planificación sin sumar otra tarea a tu lista.
        </h2>
        <p className="text-chem-navy/65 font-bold text-[10px] md:text-lg" data-id="element-156" data-mp="2rf1v64amxm8d">
          Una sola oferta de lanzamiento. Acceso digital inmediato.
        </p>
      </div>

      <div className="space-y-2 md:space-y-4 mb-4 md:mb-8" data-id="element-157" data-mp="315mp3efd62ky">
        <motion.div className="p-3 md:p-8 rounded-2xl md:rounded-3xl border-2 border-chem-petrol bg-white shadow-xl shadow-chem-navy/10 relative overflow-hidden" data-id="element-158" data-mp="2w7l3omugtr6b">
          <div className="flex items-start gap-3 md:gap-4" data-id="element-159" data-mp="28i8zy2hwqbbe">
            <div className="flex-1" data-id="element-160" data-mp="23jpd7zvhovhz">
              <div className="flex flex-wrap gap-1 md:gap-2 mb-1 md:mb-3" data-id="element-161" data-mp="23kqnw38lffz6">
                <span className="bg-chem-green text-white text-[7px] md:text-[10px] font-black px-1.5 py-0.5 rounded-full uppercase tracking-widest" data-id="element-162" data-mp="2igy6iz4cs9cc">
                  {pack.savings}
                </span>
              </div>
              <div className="flex items-center gap-1.5 md:gap-2 mb-0.5 md:mb-1" data-id="element-163" data-mp="3ttik8epabmfm">
                <FlaskConicalIcon className="text-chem-petrol w-4 h-4 md:w-6 md:h-6 shrink-0" data-id="element-164" data-mp="3ovqr5hcwlu9u" />
                <h3 className="font-black text-chem-navy text-[11px] md:text-xl uppercase leading-tight" data-id="element-165" data-mp="9m1uf2r1o9m">
                  {pack.title}
                </h3>
              </div>
              <p className="text-chem-navy/60 font-bold text-[9px] md:text-sm mb-1 md:mb-4" data-id="element-166" data-mp="3nfv4caxbmbpw">
                {pack.subtitle}
              </p>
              <ul className="space-y-1 md:space-y-2 mb-2 md:mb-6" data-id="element-167" data-mp="3rgyfwl8c5llb">
                {pack.features.map(f => <li key={f} className="flex items-start gap-1.5 text-[9px] md:text-base text-chem-navy/80 font-medium leading-tight" data-id="element-168" data-mp="j37qyuut2bb3">
                    <span className="text-chem-green font-black shrink-0" data-id="element-169" data-mp="a6qoeg0iblqy">
                      ✓
                    </span>
                    <span data-id="element-170" data-mp="11zze5fdgxakf">{f}</span>
                  </li>)}
              </ul>
              <div className="flex items-baseline gap-2 md:gap-3" data-id="element-171" data-mp="16q7htgggq6zt">
                <span className="text-chem-navy/40 line-through font-bold text-[10px] md:text-lg" data-id="element-172" data-mp="16sk7kfsgplnf">
                  {pack.oldPrice}
                </span>
                <span className="md:text-4xl font-black text-chem-navy text-[24px]" data-id="element-173" data-mp="3a85vdgf2odia">
                  {pack.price}
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      {/* PRE-CHECKOUT: Payment Info */}
      <div className="text-center mb-3 md:mb-4" data-id="element-174" data-mp="1sm8cz4zvrbo">
        <h3 className="text-chem-navy font-black text-sm md:text-base mb-2" data-id="element-175" data-mp="1rav88pnt77w">
          PAGO SEGURO Y PROTEGIDO
        </h3>
        <p className="text-chem-navy/65 font-medium text-xs md:text-sm mb-1 max-w-2xl mx-auto" data-id="element-176" data-mp="3szox7jxd1liq">
          🔒 Compra segura. El precio está expresado en dólares estadounidenses.
          En el checkout verás la conversión automática a tu moneda local según
          tu país y el medio de pago disponible. Una vez confirmado el pago,
          recibirás el acceso al material digital por correo electrónico.
        </p>
      </div>

      <motion.button animate={{
      boxShadow: ['0 0 15px rgba(22,163,74,0.2)', '0 0 30px rgba(22,163,74,0.5)', '0 0 15px rgba(22,163,74,0.2)'],
      scale: [1, 1.03, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handlePurchase} className="w-full bg-chem-green hover:bg-green-700 text-white font-black md:text-3xl py-4 md:py-6 rounded-2xl md:rounded-3xl shadow-xl shadow-green-900/20 mb-2 md:mb-3 uppercase tracking-tight text-[16px] transition-colors" data-id="element-177" data-mp="1yfeppwstil3n">
        QUIERO ACCEDER A QUÍMICA VISUAL
      </motion.button>

      <p className="text-center text-chem-petrol text-[10px] md:text-sm font-bold mb-1 md:mb-2" data-id="element-178" data-mp="2v7iacwh0toxl">
        🌎 Antes de confirmar tu compra, verás el precio convertido a tu moneda
        local.
      </p>

      {/* REDIRECT MICRO-TEXT */}
      <p className="text-center text-chem-navy/55 text-[10px] md:text-xs font-medium mb-2 md:mb-3" data-id="element-179" data-mp="150subpp3ab0r">
        Serás redirigido a una pasarela de pago segura y protegida.
      </p>

      {/* WARRANTY REINFORCEMENT */}
      <div className="flex items-start justify-center gap-2 text-center mb-4 md:mb-8 px-2" data-id="element-180" data-mp="1erf7zed8wrgt">
        <ShieldIcon size={14} className="text-chem-petrol shrink-0 mt-0.5" data-id="element-181" data-mp="1a05fm60bba18" />
        <p className="text-chem-navy/65 text-[11px] md:text-xs font-medium leading-snug" data-id="element-182" data-mp="1nrk0kids5lax">
          <span className="font-bold" data-id="element-183" data-mp="1jq8kp4kpkefx">Compra protegida y garantizada.</span> Si
          no estás conforme, tienes 7 días para pedir la devolución total de tu
          dinero.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 mb-4 md:mb-12 mt-4 md:mt-16" data-id="element-184" data-mp="1sqwwrtqjk4q6">
        {badges.map(badge => {
        const Icon = badge.icon;
        return <div key={badge.title} className="bg-white p-6 rounded-3xl border border-chem-petrol/12 text-center flex flex-col items-center" data-id="element-185" data-mp="3dtg3lg04brl">
              <div className="text-chem-petrol mb-3" data-id="element-186" data-mp="2a10rmp4gyyzm">
                <Icon className="w-6 h-6" strokeWidth={2.2} data-id="element-187" data-mp="2ezlm07x1iog5" />
              </div>
              <p className="font-black text-chem-navy text-xs md:text-sm mb-1" data-id="element-188" data-mp="20apc05bfb1cw">
                {badge.title}
              </p>
              <p className="text-chem-navy/50 text-[10px] md:text-xs font-bold" data-id="element-189" data-mp="258h7taf6v7md">
                {badge.desc}
              </p>
            </div>;
      })}
      </div>

      <div className="bg-white p-8 rounded-[2.5rem] border border-chem-petrol/12 flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-190" data-mp="1w9dn620dik5r">
        <div className="shrink-0" data-id="element-191" data-mp="1hdeiz2gdx45w">
          <img src="https://cdn.magicpatterns.com/uploads/wPdBTd5Jo7F4dpjLi12DAp/garantia-7-dias-250.webp" alt="Garantía 7 días" className="w-24 h-auto md:w-32" data-id="element-192" data-mp="1maekd02ahiqo" />
        </div>
        <div data-id="element-193" data-mp="3goxmv2mtzm8p">
          <h5 className="text-chem-navy font-black text-lg md:text-xl mb-1" data-id="element-194" data-mp="3gneahn4apvc7">
            Garantía de satisfacción de 7 días
          </h5>
          <p className="text-chem-navy/60 font-medium text-sm md:text-base" data-id="element-195" data-mp="24h58vbxp3coj">
            Explora el material con tranquilidad. Si consideras que no es
            adecuado para tus necesidades, puedes solicitar la devolución dentro
            de los 7 días posteriores a la compra, de acuerdo con las
            condiciones de garantía.
          </p>
        </div>
      </div>
    </section>;
}